import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Expanded = _resolveComponent("Expanded")
  const _component_Onboarding = _resolveComponent("Onboarding")

  return ($props.mode === 'expanded')
    ? (_openBlock(), _createBlock(_component_Expanded, {
        key: 0,
        ref: "expanded",
        "chat-id": $props.chatId,
        item: $props.item,
        "last-answer": $props.lastAnswer,
        generating: $props.generating,
        readonly: $props.readonly,
        restricted: $props.restricted,
        onLike: _cache[0] || (_cache[0] = $event => (_ctx.$emit('like', $event))),
        onDislike: _cache[1] || (_cache[1] = $event => (_ctx.$emit('dislike', $event))),
        onSave: _cache[2] || (_cache[2] = $event => (_ctx.$emit('save', $event))),
        onAskAi: _cache[3] || (_cache[3] = $event => (_ctx.$emit('ask-ai', $event))),
        onTextAdded: _cache[4] || (_cache[4] = $event => (_ctx.$emit('text-added', $event))),
        onRefrag: _cache[5] || (_cache[5] = $event => (_ctx.$emit('refrag', $event)))
      }, null, 8 /* PROPS */, ["chat-id", "item", "last-answer", "generating", "readonly", "restricted"]))
    : ($props.mode === 'onboarding')
      ? (_openBlock(), _createBlock(_component_Onboarding, {
          key: 1,
          item: $props.item,
          "last-answer": $props.lastAnswer,
          generating: $props.generating,
          onAskAi: _cache[6] || (_cache[6] = $event => (_ctx.$emit('ask-ai', $event))),
          onTextAdded: _cache[7] || (_cache[7] = $event => (_ctx.$emit('text-added', $event))),
          onCompleted: _cache[8] || (_cache[8] = $event => (_ctx.$emit('onboarding-completed', $event)))
        }, null, 8 /* PROPS */, ["item", "last-answer", "generating"]))
      : _createCommentVNode("v-if", true)
}